module.exports = __webpack_public_path__ + "static/media/button-next-over.c2841edf.svg";